export const ConfidentialClientEmployee = 9760;
export const ConfidentialClientField = 9761;
export const ConfidentialClientDeferredCompPlannerURL =
  "https://secure05.principal.com/RetirementServiceCenter/memberview?page_name=rsc_plancentertools&contract_num=";
